export function stripAwayFormErrors(formState: Record<string, any>): Record<string, any> {
    const newFormState = JSON.parse(JSON.stringify(formState));
    Object.keys(newFormState).forEach(key => {
        if (Object.hasOwn(newFormState[key], 'err') && newFormState[key].err !== '') {
            newFormState[key].err = '';
        }
    });
    return newFormState;
}
